import { FC } from "react";

interface NotificationProps {
    notificationMessage: string;
    secondRowNotificationMessage?: string | undefined;
}

const Notification: FC<NotificationProps> = (props) => {
    const { notificationMessage, secondRowNotificationMessage } = props;
             
    if (secondRowNotificationMessage) {
      return (
        <div className="notification_wrapper"> 
          <div className="notification">
              <div> {notificationMessage} </div>
              <div className="notification_second_row_fix"> {secondRowNotificationMessage} </div>
          </div>
        </div>
      );
    }
    
    return (
      <div className="notification_wrapper"> 
        <div className="notification center_horizontally_and_vertically">
            {notificationMessage}
        </div>
      </div>
    );
  };

export default Notification;
